import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';

const PaymentSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const redirectStatus = searchParams.get('redirect_status');
  const announcementId = searchParams.get('announcement');
  const paymentIntent = searchParams.get('payment_intent');

  let title = 'Payment Status';
  let message = 'We are processing your payment. You can safely close this page.';
  let state = 'processing';

  if (redirectStatus === 'succeeded') {
    title = 'Thank you for your sponsorship!';
    message = 'Your payment has been confirmed. You will see your sponsorship reflected shortly.';
    state = 'success';
  } else if (redirectStatus === 'failed' || redirectStatus === 'canceled') {
    title = 'Payment was not completed';
    message = 'Your payment could not be completed. You can try again or pick another method.';
    state = 'error';
  } else if (redirectStatus === 'requires_action') {
    title = 'Additional authentication needed';
    message = 'Please follow the instructions from your bank to complete the payment.';
    state = 'action';
  }

  return (
    <div style={{ padding: '40px 20px', maxWidth: 640, margin: '0 auto', textAlign: 'center' }}>
      <h2 style={{ marginBottom: 8 }}>{title}</h2>
      <p style={{ color: '#555', marginBottom: 24 }}>{message}</p>

      {paymentIntent && (
        <p style={{ fontSize: 12, color: '#888' }}>Reference: {paymentIntent}</p>
      )}

      {announcementId && (
        <p style={{ fontSize: 12, color: '#888' }}>Announcement: {announcementId}</p>
      )}

      <div style={{ marginTop: 32 }}>
        <Link to="/community/announcements" style={{
          display: 'inline-block',
          padding: '10px 16px',
          background: state === 'success' ? '#16a34a' : state === 'error' ? '#ef4444' : '#3b82f6',
          color: 'white',
          borderRadius: 8,
          textDecoration: 'none',
          fontWeight: 600
        }}>
          Back to Announcements
        </Link>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
